export default "__VITE_ASSET__CAbRGnfc__"